import React, { useEffect, useState, useRef, useContext } from "react"
import { Query } from "react-apollo"
import Modal, { ModalHeader, ModalContent } from "../../components/Modal"
import MyFavorites from "../../views/MyFavorites"
import { withRouter } from "react-router-dom"
import gql from "graphql-tag"
import AppContext from "../../shared/AppContext"
import { BiCabinet } from "react-icons/bi"

const getViewer = gql`
  query getViewer {
    viewer {
      id
      isUserAuthenticated
    }
  }
`

export const MyFavoriteModalContext = React.createContext()

const MyFavoritesModal = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const isMountedRef = useRef(false)
  const { className, trackingLocation } = props
  const { trackEvent } = useContext(AppContext)
  let classNames = ["access-favorites-button", className]
    .filter(Boolean)
    .join(" ")
    .trim()

  useEffect(() => {
    isMountedRef.current = true
    return () => (isMountedRef.current = false)
  }, [])

  const tryModalClose = () => {
    if (isMountedRef.current) {
      setIsModalOpen(false)
    }
  }

  return (
    <React.Fragment>
      <div
        className={classNames}
        onClick={() => {
          setIsModalOpen(true)
          trackEvent("Access My Favorites", {
            location: trackingLocation,
          })
        }}
      >
        <BiCabinet />
        <span className="button-text">Access my Favorites</span>
      </div>
      <Modal
        isOpen={isModalOpen}
        close={() => setIsModalOpen(false)}
        classes={["access-favorites-modal"]}
      >
        <ModalContent>
          <ModalHeader
            text="My Favorites"
            close={() => setIsModalOpen(false)}
          />
          {isModalOpen && (
            <Query query={getViewer}>
              {({ data, error, loading }) => {
                if (loading) return "Loading..."
                if (error) return "Error loading Favorites."
                return (
                  <MyFavoriteModalContext.Provider value={tryModalClose}>
                    <MyFavorites
                      viewer={data.viewer}
                      {...props}
                      trackingLocation="Access My Favorites"
                    />
                  </MyFavoriteModalContext.Provider>
                )
              }}
            </Query>
          )}
        </ModalContent>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(MyFavoritesModal)
